module.exports = __webpack_public_path__ + "static/media/oval@1x.56869b46.svg";